import { Img } from "components";
import { useNavigate } from "react-router-dom";
import { useSpotlight } from "../components/SpotLight";
import Stepper from "../components/Stepper";
import AvatarVideo from "../components/AvatarVideo";
import Lottie from "lottie-react";
import ResponsiveAnimation from "assets/images/ResponsiveAnimation.json"
import Wrapper from "../components/Wrapper";

const videoLinks = [
    { url: "https://soomuch.blob.core.windows.net/data-soomuch/DemoContent/AvatarVideos/launch-website.mp4" }
];

const AiWebsite = () => {
    // const videoRef = useRef(null);

    // const step1Ref = useSpotlight("");
    // const step2Ref = useSpotlight("");
    // const step3Ref = useSpotlight("");
    // const navigate = useNavigate();

    // Control video playback based on modal state
    // useEffect(() => {
    //     if (!!videoRef.current) {
    //         if (!showModal && videoPlaying) {
    //             videoRef.current.muted = false;
    //             videoRef.current.play();
    //         } else {
    //             videoRef.current.pause();
    //             videoRef.current.muted = true;
    //         }
    //     }
    // }, [showModal, videoPlaying]);

    return (
        <Wrapper
            title={<>Your Brand Website, Live in 2 Minutes.. <br /> It’s That Easy.</>}
            titleSize="text-[4.5vh]"
            // description="Let's create your online presence — fast!"
            videoLinks={videoLinks}
            body={<>
                <div className="grid grid-cols-2 gap-12 w-full mt-9 px-5">
                    <div className="space-y-5">
                        <h2 className="text-smd_blue-normal font-manropeSB text-[4vh] mb-6">What you get from website</h2>

                        <p className="flex gap-2 text-[2.4vh]">
                            <span className="font-mono">💻</span>
                            <span><span className="font-inter font-manropeSB">Fully responsive</span> (Desktop, tablet & mobile-friendly)</span>
                        </p>

                        <p className="flex gap-2 text-[2.4vh]">
                            <span className="font-mono">📈</span>
                            <span><span className="font-inter font-manropeSB">Fully Increased Admissions & Enrolment:</span> Attracts more prospective students and parents by showcasing.</span>
                        </p>

                        <p className="flex gap-2 text-[2.4vh]">
                            <span className="font-mono">🎯</span>
                            <span><span className="font-inter font-manropeSB">24/7 Marketing & Brand Visibility:</span> Acts as a digital brochure that works round the clock to promote the school.</span>
                        </p>

                        <p className="flex gap-2 text-[2.4vh]">
                            <span className="font-mono">🔥</span>
                            <span><span className="font-inter font-manropeSB">Competitive Advantage:</span> Stands out among other schools with a modern, user-friendly, and informative website.</span>
                        </p>
                    </div>

                    <div className="items-center ml-5">
                        <div className="w-full flex justify-center">
                            <h2 className="relative text-center font-manropeSB text-[2.4vh] mb-2">
                                {/* Background image behind text */}
                                <Img
                                    src="images/soomuch-demo/Line.svg"
                                    className="absolute left-1/2 bottom-0 -translate-x-1/2 z-0 pointer-events-none"
                                    alt=""
                                />
                                {/* Text in front */}
                                <span className="relative z-10">AI responsive website for you</span>
                            </h2>
                        </div>
                        <div className="rounded-lg p-3 flex justify-center">
                            <Lottie animationData={ResponsiveAnimation} /* style={{ width: 600, height: 350 }} */ className="h-[45vh]" />
                        </div>
                    </div>
                </div>
            </>}
        />
        // <div className="flex justify-center min-h-screen bg-[url(/public/images/soomuch-demo/background.svg)] bg-no-repeat bg-cover bg-center">
        //     <div className="container font-manrope p-5 flex flex-col justify-between w-full">
        //         <div className="flex">
        //             <div className="grid grid-cols-12 gap-4 w-full">
        //                 <div className="col-span-2"><Img src="images/soomuch-demo/logo.svg" /></div>
        //                 <div className="text-center self-end space-y-2 col-span-8">
        //                     <h1 className="font-raveo text-smd_blue-normal text-4xl font-[1000] leading-[120%] tracking-[-1%]">Launch Your School Website in 2 Minutes!</h1>
        //                     <p className="text-sm">Let's create your online presence — fast!</p>
        //                 </div>
        //                 <div className="flex justify-end col-span-2">
        //                     <AvatarVideo videoLinks={videoLinks} />
        //                 </div>
        //             </div>
        //         </div>

        //         <div className="grid grid-cols-2 gap-12 w-full mt-9 px-5">
        //             <div className="space-y-5">
        //                 <h2 className="text-smd_blue-normal font-manropeSB text-2xl mb-6">What you get from website</h2>

        //                 <p className="flex gap-2 text-lg">
        //                     <span className="font-mono">💻</span>
        //                     <span><span className="font-manropeSB">Fully responsive</span> (Desktop, tablet & mobile-friendly)</span>
        //                 </p>

        //                 <p className="flex gap-2 text-lg">
        //                     <span className="font-mono">📈</span>
        //                     <span><span className="font-manropeSB">Fully Increased Admissions & Enrolment:</span> Attracts more prospective students and parents by showcasing.</span>
        //                 </p>

        //                 <p className="flex gap-2 text-lg">
        //                     <span className="font-mono">🎯</span>
        //                     <span><span className="font-manropeSB">24/7 Marketing & Brand Visibility:</span> Acts as a digital brochure that works round the clock to promote the school.</span>
        //                 </p>

        //                 <p className="flex gap-2 text-lg">
        //                     <span className="font-mono">🔥</span>
        //                     <span><span className="font-manropeSB">Competitive Advantage:</span> Stands out among other schools with a modern, user-friendly, and informative website.</span>
        //                 </p>
        //             </div>

        //             <div className="items-center ml-5">
        //                 <h2 className="text-center font-bold text-lg mb-2">AI responsive website for you</h2>
        //                 <div className="rounded-lg p-3 flex justify-center">
        //                    <Lottie animationData={ResponsiveAnimation} style={{ width: 600, height: 350 }} />
        //                 </div>
        //             </div>
        //         </div>

        //         <Stepper />
        //     </div>
        // </div>
    );
};

export default AiWebsite;